module.exports = __webpack_public_path__ + "img/effects_bubble_power.8c9bb0ab.png";